<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      :title="recruiterName"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <div v-for="client in details" :key="client.Id" class="mb-15">
          <v-row
            v-if="client.submissionsCount > 0 || client.interviewsCount > 0 || client.placementsCount > 0"
            class="my-3"
          >
            <v-col cols="12">
              <h2>{{ client.clientName }}</h2>
            </v-col>
          </v-row>
          <div v-if="client.submissionsCount > 0" class="mt-1 pb-5 mx-1 section">
            <v-row class="my-2 ml-5">
              <v-col cols="12">
                <h2>Submissions</h2>
              </v-col>
            </v-row>
            <v-row v-for="submission in client.submissionsList" :key="submission.staffLynxId" class="my-1 mx-10 section-item">
              <v-col class="py-0" cols="12"><b>Job Opening:</b> {{ submission.job_Opening_Name }} - <i style="text-decoration: underline;">{{ submission.job_Opening_Status }}</i> </v-col>
              <v-col class="py-0" cols="12"><b>Candidate:</b> {{ submission.associated_Candidates[0].full_Name }} - <i style="text-decoration: underline;">{{ submission.candidate_Status }}</i></v-col>
              <v-col class="py-0" cols="12"><b>Modified Time:</b> {{ formatDate(submission.associated_Candidates[0].last_Activity_Time) }} {{ toTimeOnlyString(submission.associated_Candidates[0].last_Activity_Time) }}</v-col>
            </v-row>
          </div>
          <div v-if="client.interviewsCount > 0" class="mt-1 pb-5 mx-1 section">
            <v-row class="my-2 ml-5">
              <v-col cols="12">
                <h2>Interviews</h2>
              </v-col>
            </v-row>
            <v-row v-for="interview in client.interviewsList" :key="interview.staffLynxId" class="my-1 mx-10 section-item">
              <v-col class="py-0" cols="12"><b>Date:</b> {{ formatDate(interview.start_DateTime) }} {{ toTimeOnlyString(interview.start_DateTime) }} - {{ toTimeOnlyString(interview.end_DateTime) }}</v-col>
              <v-col class="py-0" cols="12"><b>Job Opening:</b> {{ interview.job_Opening_Name.name }}</v-col>
              <v-col class="py-0" cols="12"><b>Candidate:</b> {{ interview.candidate_Name.name }}</v-col>
            </v-row>
          </div>
          <div v-if="client.placementsCount > 0" class="mt-1 pb-5 mx-1 section">
            <v-row class="my-2 ml-5">
              <v-col cols="12">
                <h2>Placements</h2>
              </v-col>
            </v-row>
            <v-row v-for="placement in client.placementsList" :key="placement.staffLynxId" class="my-1 mx-10 section-item">
              <v-col class="py-0" cols="12"><b>Job Opening:</b> {{ placement.job_Opening_Name }} - <i style="text-decoration: underline;">{{ placement.job_Opening_Status }}</i></v-col>
              <v-col class="py-0" cols="12"><b>Consultant:</b> {{ placement.associated_Candidates[0].full_Name }} - <i style="text-decoration: underline;">{{ placement.associated_Candidates[0].candidate_Status }}</i></v-col>
              <v-col class="py-0" cols="12"><b>Modified Time:</b> {{ formatDate(placement.associated_Candidates[0].last_Activity_Time) }} {{ toTimeOnlyString(placement.associated_Candidates[0].last_Activity_Time) }}</v-col>
            </v-row>
          </div>
        </div>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-12">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Close
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { SimplePageHeader } from '@/components/pageComponents'
import { formatDate, toTimeOnlyString } from '@/lib/display'

export default {
  components: {
    DynamicModal,
    SimplePageHeader
  },
  data () {
    return {
      showModalProp: false,
      recruiterName: '',
      details: []
    }
  },
  methods: {
    formatDate,
    toTimeOnlyString,
    showModal (recruiterName, details) {
      this.recruiterName = recruiterName
      this.details = details
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.$emit('closeModal')
    }
  }
}
</script>
<style>
.section {
  border: 0.1em solid #cccccc;
  border-radius: 7px;
}
.section-item {
  border: 0.1em solid #cccccc;
  border-radius: 7px;
}
</style>
